import { gql } from '@graphql/__generated__';

export const ENHANCE_IMAGE = gql(/* GraphQL */ `
  mutation EnhanceImage(
    $prompt: String!
    $source_image_data: String!
    $aspect_ratio: String
    $image_size: String
  ) {
    enhance_image(
      prompt: $prompt
      source_image_data: $source_image_data
      aspect_ratio: $aspect_ratio
      image_size: $image_size
    ) {
      image_data
    }
  }
`);
